// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Api from "../Utills/Api";
// import "react-toastify/dist/ReactToastify.css";
// import "./Profile.css";

// const Sidebar = ({ activeButton, onButtonClick, fetchWalletData, wallet }) => {
//   const buttons = [
//     { id: 1, label: "My Profile" },
//     { id: 2, label: "Order History" },
//     { id: 3, label: "Wallet Transactions" },
//     { id: 4, label: "Your QR Code" },
//     { id: 6, label: "My References" },
//     { id: 5, label: "Log Out" },
//   ];

//   useEffect(() => {
//     const tab = window.location.href.split("?").length > 1 ? window.location.href.split("?")[1].split("=")[1] : null;
//     if (tab) {
//       onButtonClick(parseInt(tab));
//     }
//   }, []);
  
//   const [name, setName] = useState("");
//   const [photo, setPhoto] = useState("");
//   const [influencerRecord, setInfluencerRecord] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const access = localStorage.getItem("access_token");
//     if (!access) {
//       navigate("/login");
//     }
    
//     const getProfileAndWallet = async () => {
//       const uid = localStorage.getItem("user_id");

//       try {
//         // Fetch profile data
//         const profileResponse = await Api.get(`api/profile/?user_id=${uid}`);
//         setPhoto(profileResponse.data.profile_photo);
//         setName(profileResponse.data.name);
//         setInfluencerRecord(profileResponse.data.influencer_record || null);
        
//         // Fetch wallet data on initial load
//         await fetchWalletData();
        
//       } catch (error) {
//         console.log("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     getProfileAndWallet();
//   }, []);

//   // Enhanced button click handler
//   const handleButtonClick = async (buttonId) => {
//     // Fetch wallet data before changing the active button
//     await fetchWalletData();
    
//     // Call the original onButtonClick handler
//     onButtonClick(buttonId);
//   };

//   return (
//     <div className="sidebar-wrapper">
//       {loading ? (
//         <div className="loading-text">Loading...</div>
//       ) : (
//         <>
//           <div className="sidebar-header">
//             <img
//               src={
//                 photo ||
//                 "./img/gallery/akash.jpeg"
//               }
//               alt="Profile"
//               className="sidebar-profile-image"
//             />
//             <h2 className="sidebar-profile-name">
//               {name}
//             </h2>
//             {influencerRecord ? (
//               <div style={{ marginTop: 6 }}>
//                 <span
//                   className="influencer-badge"
//                 >
//                   Influencer
//                 </span>
//               </div>
//             ) : null}
//           </div>
//           <hr className="sidebar-divider" />

//           <div className="sidebar-buttons">
//             {buttons.map((button) => (
//               <button
//                 key={button.id}
//                 className={`sidebar-button ${button.id === activeButton ? "active" : ""}`}
//                 onClick={() => handleButtonClick(button.id)}
//               >
//                 {button.label}
//               </button>
//             ))}
//           </div>
//           <div className="wallet-balance-section">
//             <span>Wallet Balance:</span>
//             <span className="wallet-balance-text">₹{wallet}</span>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default Sidebar;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../Utills/Api";
import "react-toastify/dist/ReactToastify.css";
import "./Profile.css";

const getInitials = (name) => {
  if (!name) return "?";
  const nameParts = name.trim().split(" ");
  if (nameParts.length === 1) {
    return nameParts[0].charAt(0).toUpperCase();
  }
  return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
};

const getColorFromName = (name) => {
  if (!name) return "#6366f1";
  
  const colors = [
    "#6366f1", // Indigo
    "#8b5cf6", // Violet
    "#ec489a", // Pink
    "#f43f5e", // Rose
    "#ef4444", // Red
    "#5dc5fa", // Orange
    "#f59e0b", // Amber
    "#84cc16", // Lime
    "#10b981", // Emerald
    "#14b8a6", // Teal
    "#06b6d4", // Cyan
    "#3b82f6", // Blue
  ];
  
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = ((hash << 5) - hash) + name.charCodeAt(i);
    hash = hash & hash;
  }
  return colors[Math.abs(hash) % colors.length];
};

const Sidebar = ({ activeButton, onButtonClick, fetchWalletData, wallet }) => {
  const buttons = [
    { id: 1, label: "My Profile" },
    { id: 2, label: "Order History" },
    { id: 3, label: "Wallet Transactions" },
    { id: 4, label: "Your QR Code" },
    { id: 6, label: "My References" },
    { id: 5, label: "Log Out" },
  ];

  useEffect(() => {
    const tab = window.location.href.split("?").length > 1 ? window.location.href.split("?")[1].split("=")[1] : null;
    if (tab) {
      onButtonClick(parseInt(tab));
    }
  }, []);
  
  const [name, setName] = useState("");
  const [photo, setPhoto] = useState("");
  const [influencerRecord, setInfluencerRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imageError, setImageError] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const access = localStorage.getItem("access_token");
    if (!access) {
      navigate("/login");
    }
    
    const getProfileAndWallet = async () => {
      const uid = localStorage.getItem("user_id");

      try {
        // Fetch profile data
        const profileResponse = await Api.get(`api/profile/?user_id=${uid}`);
        setPhoto(profileResponse.data.profile_photo);
        setName(profileResponse.data.name);
        setInfluencerRecord(profileResponse.data.influencer_record || null);
        
        // Fetch wallet data on initial load
        await fetchWalletData();
        
      } catch (error) {
        console.log("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    getProfileAndWallet();
  }, []);

  // Enhanced button click handler
  const handleButtonClick = async (buttonId) => {
    // Fetch wallet data before changing the active button
    await fetchWalletData();
    
    // Call the original onButtonClick handler
    onButtonClick(buttonId);
  };

  // Render profile image or initials
  const renderProfileImage = () => {
    if (photo && !imageError) {
      return (
        <img
          src={photo}
          alt="Profile"
          className="sidebar-profile-image"
          onError={() => setImageError(true)}
        />
      );
    }

    const initials = getInitials(name);
    const backgroundColor = getColorFromName(name);
    
    return (
      <div 
        className="sidebar-profile-initials"
        style={{
          backgroundColor: backgroundColor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "80px",
          height: "80px",
          borderRadius: "50%",
          fontSize: "32px",
          fontWeight: "600",
          color: "white",
          margin: "0 auto"
        }}
      >
        {initials}
      </div>
    );
  };

  return (
    <div className="sidebar-wrapper">
      {loading ? (
        <div className="loading-text">Loading...</div>
      ) : (
        <>
          <div className="sidebar-header">
            {renderProfileImage()}
            <h2 className="sidebar-profile-name">
              {name}
            </h2>
            {influencerRecord ? (
              <div style={{ marginTop: 6 }}>
                <span className="influencer-badge">
                  Influencer
                </span>
              </div>
            ) : null}
          </div>
          <hr className="sidebar-divider" />

          <div className="sidebar-buttons">
            {buttons.map((button) => (
              <button
                key={button.id}
                className={`sidebar-button ${button.id === activeButton ? "active" : ""}`}
                onClick={() => handleButtonClick(button.id)}
              >
                {button.label}
              </button>
            ))}
          </div>
          <div className="wallet-balance-section">
            <span>Wallet Balance:</span>
            <span className="wallet-balance-text">₹{wallet}</span>
          </div>
        </>
      )}
    </div>
  );
};

export default Sidebar;